export default __webpack_public_path__ + "5b798ea3b8c2ace5bedd15368ba27d7f.png";